import React from 'react'

export default function Header() {
  return (
    <header className="header">

      <nav className="navbar">
        <div className="nav_logo">3W-CODE</div>
        <div className="navigation">
          <a className="nav_link" href="#explain">A propos</a>
          <a className="nav_link" href="#method">Méthodologie</a>
          <a className="nav_link active" href="#contact">Contact</a>
        </div>
      </nav>

      <div className="center header_content">
        <div className="header_text_container">
          <h1 className="main_title">
            Commencer à coder aujourd'hui
          </h1>
          <p className="header_mini_text">
            Apprenez à coder et devenez développeur web en ligne en seulement 3 semaines. De 0 à votre première mission freelance.
          </p>
        </div>
      </div>
    </header>
  )
}
